const RECEIVE_ALL_OMNI_RETAILERS = 'src/omniRetailers/RECEIVE_ALL_OMNI_RETAILERS' as const;
const RECEIVE_ALL_OMNI_INSTACART_RETAILERS = 'src/omniRetailers/RECEIVE_ALL_OMNI_INSTACART_RETAILERS' as const;
const START_FETCH = 'src/omniRetailers/START_FETCH' as const;

export default { START_FETCH, RECEIVE_ALL_OMNI_RETAILERS, RECEIVE_ALL_OMNI_INSTACART_RETAILERS };
